
export default {
	components: {
		breadcrumbs: () => import('../../components/pages/breadcrumbs.vue')
	}
}
